import _ from 'lodash';
import Collection from '@skyjs/collection';

export default function makeUpdateFeatureFile(onContextChange, context) {
  let _events = new Collection();

  const update = _.debounce(async () => {
    const events = _events;
    _events = new Collection();

    for (const entry of Object.entries(events.groupBy('aggregateId'))) {
      const aggregateId = entry[0];
      const aggregateEvents = await getAggregateEvents(aggregateId, entry[1], context);

      let file = _.find(context.app.files, { id: aggregateId });

      for (const event of aggregateEvents.orderBy('aggregateVersion')) {
        if (file) {
          if (event.data._deleted) {
            delete context.app.files[file.moduleId];
          } else {
            file = { ...file, ...event.data };

            if (event.data.moduleId !== event.previousData.moduleId) {
              delete context.app.files[event.previousData.moduleId];
            }

            context.app.files[file.moduleId] = file;
          }
        } else if (event.data._deleted === '$remove') {
          file = await context.db.FeatureFile.get(aggregateId);
          if (file) {
            context.app.files[file.moduleId] = file;
          }
        } else if (!event.data._deleted) {
          file = event.data;
          context.app.files[file.moduleId] = file;
        }
      }
    }

    context.updateApp();
    onContextChange({ ...context });
  }, 10);

  return event => {
    _events.push(event);
    update();
  };
}

const getAggregateEvents = async (aggregateId, aggregateEvents, context) => {
  if (
    aggregateEvents.some([
      { data: null },
      { previousData: null, aggregateVersion: { notEqual: 1 } }
    ])
  ) {
    const minVersion = _.min(aggregateEvents.map('aggregateVersion'));
    const allEvents = await context.getAggregateEvents(aggregateId, minVersion - 1);
    return aggregateEvents.map(e => _.find(allEvents, { aggregateVersion: e.aggregateVersion }));
  } else {
    return aggregateEvents;
  }
};
